import { useState, useRef, useEffect } from "react";

const OTPInput = ({ getPin }) => {
  const [pin, setPin] = useState(["", "", "", ""]);
  const [focusedIndex, setFocusedIndex] = useState(null);
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current && focusedIndex !== null) {
      inputRef.current.focus();
    }
  }, [focusedIndex]);

  const handlePinChange = (event) => {
    const value = event.target.value;
    // Allow only digits
    if (!(/^\d*$/.test(value))) return;

    // clone the current PIN array
    const newPin = [...pin];
    
    // update the currently focused index

    if (focusedIndex !== null && focusedIndex < newPin.length) {
      newPin[focusedIndex] = value.slice(-1)
      setPin(newPin);
    }

     // Move focus to next slot if not at the end
    if (value && focusedIndex < newPin.length - 1) {
      setFocusedIndex(focusedIndex + 1);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Backspace") {
      if (focusedIndex !== null && focusedIndex > 0) {
        const newPin = [...pin];
        newPin[focusedIndex] = "";
        setPin(newPin);
        setFocusedIndex(focusedIndex - 1);
      }
    }
  };

  const handleBlur = () => {
    setFocusedIndex(null);
  };

  useEffect(() => {
    if (pin.every(digit => digit !== "")) {
      getPin(pin.join(""));
    }
  }, [pin, getPin]);

  return (
    <div style={styles.container}>
      <div style={styles.pinContainer}>
        {pin.map((digit, index) => (
          <div
            key={index}
            style={{
              ...styles.pinDigit,
              // Apply focused border style conditionally
              borderWidth: focusedIndex === index ? "2px" : "2px",
              borderStyle: "solid",
              borderColor: focusedIndex === index ? "blue" : "#ccc",
            }}
            onClick={() => setFocusedIndex(index)}
          >
            {digit}
          </div>
        ))}
      </div>
      <input
        ref={inputRef}
        type="tel"
        value={pin[focusedIndex] || ""}
        onChange={handlePinChange}
        onKeyDown={handleKeyDown}
        maxLength={2}
        style={styles.hiddenInput}
        onBlur={handleBlur}
      />
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    marginTop: 20,
  },
  label: {
    marginBottom: 10,
    fontSize: 16,
  },
  pinContainer: {
    display: "flex",
    justifyContent: "space-between",
    cursor: "text",
    gap: 10,
  },
  pinDigit: {
    width: 82,
    height: 70,
    fontSize: 20,
    fontWeight: 700,
    color: "#757575",
    textAlign: "center",
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    // Removed the border shorthand property
    transition: "border-color 0.3s", // Keep transition for smooth effect
  },
  // Removed focusedDigit style since we're handling it inline
  hiddenInput: {
    width: 1,
    height: 1,
    opacity: 0,
    position: "absolute",
    top: 0,
    left: 0,
    zIndex: -1,
  },
};

export default OTPInput;
